import React from 'react';
import styled from 'styled-components';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import { COLORS } from 'shared/design-system/settings/variables/Colors';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';

export type ReactChild =
  | React.ReactElement
  | React.ReactElement[]
  | string
  | number
  | React.ReactNode
  | React.ReactNode[];

interface ContributionMappingColumnPropsBase {
  error?: boolean;
  className?: string;
}

type ContributionMappingColumnProps = ContributionMappingColumnPropsBase &
  (
    | { type: 'column'; heading: ReactChild; subheading?: ReactChild }
    | {
        type: 'value';
        children: ReactChild;
      }
  );

const StyledDiv = styled.div<{ error?: boolean }>`
  border-radius: ${SPACERS.extraTiny};
  background-color: ${COLORS.grayLightest};
  padding: ${SPACERS.small} ${SPACERS.medium};
  border: 1px solid ${({ error }) => (error ? COLORS.critical : 'transparent')};
  height: 100%;
  .contribution-mapping-column {
    margin-bottom: ${SPACERS.extraTiny};
  }
`;

const ContributionMappingColumn: React.FC<ContributionMappingColumnProps> = props => {
  return (
    <StyledDiv error={props.error} className={props.className}>
      {props.type === 'column' ? (
        <>
          <TrueImpactText
            variant="body-bold"
            className="contribution-mapping-column"
          >
            {props.heading}
          </TrueImpactText>
          <TrueImpactText variant="body-small">
            {props.subheading}
          </TrueImpactText>
        </>
      ) : (
        props.children
      )}
    </StyledDiv>
  );
};

export default ContributionMappingColumn;
